// extracted by mini-css-extract-plugin
module.exports = {"superInput":"SuperInputText_superInput__5mhuE","errorInput":"SuperInputText_errorInput__35mWl","error":"SuperInputText_error__3m9Cm","label":"SuperInputText_label__2MdYL"};